module.exports = __webpack_public_path__ + "img/mesco.765ffa72.webp";